export default __webpack_public_path__ + "static/media/backgroundmobile.f05d99f5.png";